import persisted from '@/helpers/modules/auth';

export function extractStoreHeader(config) {
  let storeID = null;

  try {
    storeID = config.data.header_store_id;
    delete config.data.header_store_id;
  } catch (err) { /* */ }

  try {
    storeID = config.params.header_store_id;
    delete config.params.header_store_id;
  } catch (err) { /* */ }

  config.headers['Store-Id'] = storeID;
}

export function extractBearerHeader(config) {
  config.headers.Authorization = `Bearer ${persisted.token}`;
}

export function removeInternalParams(config) {
  Object.keys(config.params || {}).forEach((key) => {
    if (key.match(/^CRUDL_/)) {
      delete config.params[key];
    }
  });
}
